/* @ngInject */
const phoneLabels = () => {
  const self = {}

  self.name = (_size = 0, _point = false) => {
    return 'Téléphone' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
  }
  self.empty = 'Aucun téléphone'
  self.success = {
    delete: 'Le téléphone a bien été supprimé',
  }
  self.invalid = {
    id: 'L\'id est invalide',
    contactId: 'L\'id du contact est invalide',
  }
  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce téléphone ?',
  }

  self.log = {
    delete: {
      success: 'Le téléphone a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression du téléphone.',
    },
  }

  return self
}

export default phoneLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/resources/labels.resource.js